
































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class SlideModalCard extends Vue {
  @Prop({ required: false, default: false })
  public blockCancellation!: boolean;

  @Prop({ required: true })
  public title!: string;

  @Prop({ default: "is-dark" })
  public progressType!: string;

  @Prop({ default: null })
  public progress!: number | null;

  @Prop({ default: false })
  public isProcessing!: boolean;

  @Prop({ default: "_action.cancel" })
  public cancelText!: string;

  @Prop({ required: false, default: null })
  public type!: string;

  @Watch("blockCancellation", { immediate: true })
  public onBlockCancellation(newVal) {
    if (
      this.$_.isFunction(this.$_.get(this, "parentModal.setBlockCancellation"))
    ) {
      this.parentModal.setBlockCancellation(newVal);
    }
  }

  public bubbleEmit(event, detail) {
    try {
      this.$el.dispatchEvent(new CustomEvent(event, { detail }));
    } catch (e) {
      // handle IE not supporting Event constructor
      const evt = document.createEvent("CustomEvent");
      evt.initCustomEvent(event, true, false, detail);
      this.$el.dispatchEvent(evt);
    }
  }

  public get canCancelByButton() {
    if (!this.parentModal) {
      return false;
    }
    const cancelOptions = this.parentModal.cancelOptions;
    return cancelOptions && cancelOptions.includes("button");
  }

  public get parentModal() {
    return this.getParentModal(this);
  }

  public getParentModal(vue) {
    if (!vue.$parent) {
      return vue;
    }
    return ["SlideModal"].includes(this.$_.get(vue, "constructor.options.name"))
      ? vue
      : this.getParentModal(vue.$parent);
  }
}
